import { EmbeddedDocumentPanel } from 'features/libra/document/EmbeddedDocumentPanel'
import type { DocumentRegion } from 'features/libra/document/LibraDocumentContext'
import { FC } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
`

export const Component: FC<{ liveZones: readonly DocumentRegion[] }> = ({
  liveZones,
}) => (
  <Container>
    <EmbeddedDocumentPanel liveZones={liveZones} />
  </Container>
)
